import { render, staticRenderFns } from "./cModalDelete.vue?vue&type=template&id=c977282e&scoped=true"
import script from "./cModalDelete.vue?vue&type=script&lang=js"
export * from "./cModalDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c977282e",
  null
  
)

export default component.exports